import { render, staticRenderFns } from "./main-visual-video.vue?vue&type=template&id=27d68e6c"
import script from "./main-visual-video.vue?vue&type=script&lang=js"
export * from "./main-visual-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports